var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"app-header"}},[_vm._v(" ML Models ")])
}
var staticRenderFns = []

export { render, staticRenderFns }